var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"nkn-news"},[_c('div',{staticClass:"body-container"},[_c('div',{staticClass:"common-title"},[_vm._v(_vm._s(_vm.$t("news.title")))]),_vm._v(" "),_c('news-social'),_vm._v(" "),_c('news-youtube')],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1201e2da","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/NewsPortal.vue
// module id = null
// module chunks = 